import { useCallback } from "react";
import type { Category, EventId, PlanEvent } from "../../../shared/types";
import type { PendingRecurrence } from "./use-week-calendar-state";
import type { UpdateEventData } from "../../events/types/event-form-types";

export interface DetachOccurrenceData {
  title: string;
  category: Category;
  date: string;
  startTime: string;
  endTime: string;
  description: string;
  notes: string;
  tags: readonly string[];
  reminderMinutes: number | null;
}

interface UseUpdateEventHandlerParams {
  readonly events: PlanEvent[];
  readonly setPendingRecurrence?: (pending: PendingRecurrence | null) => void;
  readonly onUpdateEvent?: (id: EventId, updates: UpdateEventData) => void;
}

export function useUpdateEventHandler({
  events,
  setPendingRecurrence,
  onUpdateEvent,
}: UseUpdateEventHandlerParams) {
  const handleUpdateEvent = useCallback(
    (id: EventId, updates: UpdateEventData) => {
      const event = events.find((e) => e.id === id);
      if (!event?.recurrence?.type) {
        onUpdateEvent?.(id, updates);
        return;
      }

      setPendingRecurrence?.({
        kind: "update",
        event,
        updates: {
          date: updates.date,
          startTime: updates.startTime,
          endTime: updates.endTime,
        },
      });
    },
    [
      events,
      onUpdateEvent,
      setPendingRecurrence,
    ],
  );

  return { handleUpdateEvent };
}
